import { render, staticRenderFns } from "./LinhaPassageirosTable.vue?vue&type=template&id=70506f22&"
import script from "./LinhaPassageirosTable.vue?vue&type=script&lang=js&"
export * from "./LinhaPassageirosTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports